<template>
  <div class="w-full">
    <vs-popup
      :active.sync="localActive"
      class="modal-apple-nps"
      title=" "
      button-close-hidden
    >
      <div id="importar-nps-container" class="vs-con-loading__container apple-modal-wrapper" @click.stop>
        <!-- Apple Style Close Button -->
        <button type="button" class="apple-close-btn" @click="closeModal" title="Fechar">
          <vs-icon icon="close" size="16px"></vs-icon>
        </button>

        <!-- Header Apple Style -->
        <div class="apple-modal-header mb-5">
          <div class="flex items-center gap-3">
            <div class="apple-header-icon-box">
              <vs-icon icon="cloud_upload" size="22px" color="#0071e3"></vs-icon>
            </div>
            <div>
              <h3 class="apple-modal-title">Importar Respostas NPS</h3>
              <p class="apple-modal-subtitle">
                Faça upload do relatório de WhatsApp Flows exportado da Meta ou WATI.
              </p>
            </div>
          </div>
        </div>

        <!-- ETAPA: RESULTADO DA IMPORTAÇÃO -->
        <div v-if="etapa === 'resultado'" class="py-6 px-2">
          <div class="text-center mb-8">
            <div class="apple-progress-status-icon mb-3">
              <vs-icon
                v-if="resultado.erros === 0"
                icon="check_circle"
                size="56px"
                color="#34c759"
              ></vs-icon>
              <vs-icon
                v-else
                icon="warning"
                size="56px"
                color="#ff9500"
              ></vs-icon>
            </div>

            <h4 class="apple-progress-heading text-slate-800">
              Importação Finalizada com Sucesso!
            </h4>
            <p class="text-xs text-slate-400 mt-1">
              O painel de NPS e as métricas foram atualizados com os dados importados.
            </p>
          </div>

          <!-- Cards de Resumo Apple Style -->
          <div class="apple-metrics-grid mb-8">
            <div class="apple-metric-card">
              <span class="apple-metric-num text-slate-800">{{ resultado.totalLido }}</span>
              <span class="apple-metric-label">Linhas Lidas</span>
            </div>
            <div class="apple-metric-card apple-metric-card-success">
              <span class="apple-metric-num text-emerald-600">{{ resultado.importados }}</span>
              <span class="apple-metric-label">Importadas</span>
            </div>
            <div class="apple-metric-card apple-metric-card-warning">
              <span class="apple-metric-num text-amber-600">{{ resultado.duplicadosIgnorados }}</span>
              <span class="apple-metric-label">Duplicados Ignorados</span>
            </div>
            <div class="apple-metric-card apple-metric-card-danger" v-if="resultado.erros > 0">
              <span class="apple-metric-num text-rose-600">{{ resultado.erros }}</span>
              <span class="apple-metric-label">Erros / Inválidos</span>
            </div>
          </div>

          <div class="text-center">
            <button type="button" class="apple-btn apple-btn-primary" @click="finalizar">
              Concluir e Atualizar Dashboard
            </button>
          </div>
        </div>

        <!-- ETAPA: UPLOAD DO ARQUIVO -->
        <div v-else>
          <!-- Dica de Desduplicação Apple Style -->
          <div class="apple-callout-box mb-5">
            <div class="apple-callout-icon">
              <vs-icon icon="verified_user" size="18px" color="#16a34a"></vs-icon>
            </div>
            <div class="apple-callout-text">
              <strong>Desduplicação Inteligente:</strong> Ao importar relatórios de períodos sobrepostos (ex: últimos 7 dias), respostas com o mesmo telefone e horário são identificadas automaticamente para manter as métricas 100% íntegras.
            </div>
          </div>

          <!-- Dropzone de Arquivo Apple Style -->
          <div
            class="apple-dropzone mb-6"
            :class="{ 'has-file': arquivoSelecionado, 'is-dragging': dragOver }"
            @dragover.prevent="dragOver = true"
            @dragleave.prevent="dragOver = false"
            @drop.prevent="onDropFile"
            @click="triggerFileInput"
          >
            <input
              type="file"
              ref="fileInput"
              accept=".csv,.txt,.xlsx"
              class="hidden"
              style="display: none;"
              @change="onFileChange"
            />

            <div v-if="arquivoSelecionado" class="apple-file-info">
              <div class="apple-file-icon-box">
                <vs-icon icon="insert_drive_file" size="36px" color="#0071e3"></vs-icon>
              </div>
              <h5 class="apple-file-name">{{ arquivoSelecionado.name }}</h5>
              <p class="apple-file-size">
                {{ formatFileSize(arquivoSelecionado.size) }} • Clique ou arraste para substituir
              </p>
            </div>
            <div v-else class="apple-drop-placeholder">
              <div class="apple-upload-circle">
                <vs-icon icon="cloud_upload" size="32px" color="#64748b"></vs-icon>
              </div>
              <h5 class="apple-drop-title">
                Clique para selecionar ou arraste o arquivo CSV aqui
              </h5>
              <p class="apple-drop-subtitle">
                Suporta o arquivo original exportado da Meta / WhatsApp Flows (.csv)
              </p>
            </div>
          </div>

          <!-- Rodapé Apple Actions -->
          <div class="apple-modal-footer">
            <button type="button" class="apple-btn apple-btn-secondary" @click="closeModal">
              Cancelar
            </button>
            <button
              type="button"
              class="apple-btn apple-btn-primary"
              :disabled="!arquivoSelecionado || processando"
              @click="enviarArquivo"
            >
              <vs-icon icon="file_upload" size="16px" class="mr-1"></vs-icon>
              {{ processando ? 'Processando Respostas...' : 'Importar Respostas' }}
            </button>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: "ModalImportarNps",
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localActive: false,
      etapa: "upload", // 'upload' | 'resultado'
      dragOver: false,
      arquivoSelecionado: null,
      processando: false,
      resultado: {
        totalLido: 0,
        importados: 0,
        duplicadosIgnorados: 0,
        erros: 0
      }
    };
  },
  watch: {
    active(val) {
      this.localActive = val;
      if (val) {
        this.etapa = "upload";
        this.arquivoSelecionado = null;
      }
    },
    localActive(val) {
      this.$emit("update:active", val);
    }
  },
  methods: {
    closeModal() {
      this.localActive = false;
    },
    triggerFileInput() {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click();
      }
    },
    onFileChange(e) {
      const files = e.target.files || (e.dataTransfer && e.dataTransfer.files);
      if (files && files.length > 0) {
        this.arquivoSelecionado = files[0];
      }
    },
    onDropFile(e) {
      this.dragOver = false;
      const files = e.dataTransfer && e.dataTransfer.files;
      if (files && files.length > 0) {
        this.arquivoSelecionado = files[0];
      }
    },
    formatFileSize(bytes) {
      if (!bytes) return "0 KB";
      const kb = bytes / 1024;
      if (kb < 1024) return kb.toFixed(1) + " KB";
      return (kb / 1024).toFixed(1) + " MB";
    },
    async enviarArquivo() {
      if (!this.arquivoSelecionado) return;

      this.processando = true;
      this.$vs.loading({
        container: "#importar-nps-container",
        scale: 0.6
      });

      try {
        const fileReader = new FileReader();
        const csvContent = await new Promise((resolve, reject) => {
          fileReader.onload = (e) => resolve(e.target.result);
          fileReader.onerror = (e) => reject(e);
          fileReader.readAsText(this.arquivoSelecionado, "UTF-8");
        });

        const res = await this.$http.post("nps/importar", {
          csv: csvContent,
          fileName: this.arquivoSelecionado.name
        });

        if (res && res.success && res.resultado) {
          this.resultado = {
            totalLido: res.resultado.totalLido || 0,
            importados: res.resultado.importados || 0,
            duplicadosIgnorados: res.resultado.duplicadosIgnorados || 0,
            erros: res.resultado.erros || 0
          };
          this.etapa = "resultado";
          this.$vs.notify({
            title: "Importação Concluída",
            text: res.message || "Respostas importadas com sucesso!",
            color: "success",
            icon: "check"
          });
        } else {
          this.$vs.notify({
            title: "Erro na Importação",
            text: (res && res.message) || "Não foi possível processar o arquivo.",
            color: "danger",
            icon: "error"
          });
        }
      } catch (err) {
        this.$vs.notify({
          title: "Erro ao Enviar Arquivo",
          text: (err && err.response && err.response.data && err.response.data.message) || "Falha na comunicação com o servidor.",
          color: "danger",
          icon: "error"
        });
      } finally {
        this.processando = false;
        this.$vs.loading.close("#importar-nps-container > .con-vs-loading");
      }
    },
    finalizar() {
      this.closeModal();
      this.$emit("concluido");
    }
  }
};
</script>

<style scoped>
/* Apple Modal Overrides */
::v-deep .vs-popup {
  width: 92vw !important;
  max-width: 820px !important;
  border-radius: 20px !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  box-shadow: 0 30px 60px -12px rgba(0, 0, 0, 0.25), 0 18px 36px -18px rgba(0, 0, 0, 0.15) !important;
  overflow: hidden !important;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Inter", sans-serif !important;
}

::v-deep .vs-popup--header {
  display: none !important;
}

::v-deep .vs-popup--content {
  padding: 0 !important;
  margin: 0 !important;
}

.apple-modal-wrapper {
  position: relative;
  padding: 28px 32px;
  background: #ffffff;
}

.apple-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #f1f5f9;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 10;
}
.apple-close-btn:hover {
  background: #e2e8f0;
  color: #0f172a;
}

/* Header */
.apple-header-icon-box {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #f0f7ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.apple-modal-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.3px;
}

.apple-modal-subtitle {
  font-size: 0.85rem;
  color: #64748b;
  margin: 2px 0 0 0;
}

/* Callout Box */
.apple-callout-box {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 12px;
  padding: 12px 16px;
}
.apple-callout-icon {
  margin-top: 1px;
}
.apple-callout-text {
  font-size: 12px;
  color: #166534;
  line-height: 1.45;
}

/* Dropzone */
.apple-dropzone {
  border: 2px dashed #cbd5e1;
  border-radius: 16px;
  padding: 36px 20px;
  text-align: center;
  cursor: pointer;
  background: #f8fafc;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}
.apple-dropzone:hover,
.apple-dropzone.is-dragging {
  border-color: #0071e3;
  background: #f0f7ff;
}
.apple-dropzone.has-file {
  border-color: #0071e3;
  background: #f0f7ff;
}

.apple-upload-circle {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
}

.apple-drop-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 4px 0;
}
.apple-drop-subtitle {
  font-size: 12px;
  color: #94a3b8;
  margin: 0;
}

.apple-file-icon-box {
  margin-bottom: 8px;
}
.apple-file-name {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 4px 0;
}
.apple-file-size {
  font-size: 12px;
  color: #64748b;
  margin: 0;
}

/* Footer & Buttons */
.apple-modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.apple-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  border-radius: 10px;
  padding: 10px 22px;
  border: none;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.apple-btn-secondary {
  background: #f1f5f9;
  color: #475569;
}
.apple-btn-secondary:hover {
  background: #e2e8f0;
  color: #0f172a;
}

.apple-btn-primary {
  background: #0071e3;
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 113, 227, 0.25);
}
.apple-btn-primary:hover {
  background: #005bb5;
  box-shadow: 0 4px 12px rgba(0, 113, 227, 0.35);
  transform: translateY(-1px);
}
.apple-btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Metrics Grid */
.apple-metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  gap: 14px;
}

.apple-metric-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.apple-metric-num {
  font-size: 1.75rem;
  font-weight: 800;
  line-height: 1.2;
}

.apple-metric-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #64748b;
  margin-top: 4px;
}
</style>
